import { CueNote } from "../types";

export function isCueNote(obj: any): obj is CueNote {
  return !!obj &&
    typeof obj.id === "string" &&
    typeof obj.title === "string" &&
    Array.isArray(obj.triggers) &&
    obj.triggers.every((t: any) => typeof t === "string" && t.trim().length > 0) &&
    typeof obj.body_markdown === "string";
}

export function isCueNotes(input: unknown): input is CueNote[] {
  return Array.isArray(input) && input.every(isCueNote);
}

export function toCueNotes(input: unknown): CueNote[] | null {
  if (Array.isArray(input)) return isCueNotes(input) ? input : null;
  if (isCueNote(input)) return [input];
  return null;
}

export function countNotes(notes: CueNote[]) {
  return {
    notes: notes.length,
    triggers: notes.reduce((a, n) => a + (n.triggers?.length || 0), 0),
  };
}